import React, { useCallback, useState } from 'react';
import QuestionCircleOutlined from '@ant-design/icons/lib/icons/QuestionCircleOutlined';
import Button from 'antd/lib/button';
import Tooltip from 'antd/lib/tooltip';
import { WHATS_NEW_NEXA_HELP } from '@src/utils/help/links';
import { StyledWhatsNew } from './styled';

const WhatsNew = () => {
  const [isHovered, setIsHovered] = useState(false);

  const lcUrl = WHATS_NEW_NEXA_HELP;

  const handleMouseOver = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseOut = useCallback(() => {
    setIsHovered(false);
  }, []);

  const handleClick = React.useCallback(() => {
    window.open(lcUrl, '_blank');
  }, []);

  return (
    <StyledWhatsNew>
      <Tooltip title="What's New in Nexa">
        <Button
          color="primary"
          variant="link"
          icon={<QuestionCircleOutlined />}
          iconPosition="end"
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          onClick={handleClick}
          style={{
            fontWeight: isHovered ? 600 : undefined,
            textDecoration: 'underline',
          }}
        >
          What&apos;s New
        </Button>
      </Tooltip>
    </StyledWhatsNew>
  );
};

export default WhatsNew;
